import echarts from 'echarts/lib/echarts';

import 'echarts/lib/chart/line';

export default echarts;
